import { Module } from 'src/domain';
import { useUpdateModuleInheritance } from 'src/hooks/split-levels/useUpdateModuleInheritance';

export const useNoosShareUpdateInheritance = (standalone = true) =>
    useUpdateModuleInheritance(Module.NoosShare, standalone);
